import { motion } from "framer-motion";
import { Wordmark } from "./Logo";
import { MapEmbed } from "./MapEmbed";
import { CONTACT, waLink } from "../data/site";

export const Footer = () => (
  <footer data-testid="footer" data-hide-wa className="bg-ink text-paper px-5 sm:px-10 pt-20 pb-8 overflow-hidden">
    <div className="grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-7">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-paper/70">( Alfa Gráfica Digital )</p>
        <a href={waLink("Olá, Alfa Gráfica Digital! Gostaria de solicitar um orçamento.")} target="_blank" rel="noopener noreferrer" data-testid="footer-cta" className="group mt-5 inline-block font-display uppercase text-3xl sm:text-5xl leading-[0.95]">
          Sua marca merece<br /><em className="text-lime">uma boa impressão.</em><span className="hidden sm:inline-block ml-2 transition-transform duration-500 group-hover:translate-x-3">→</span>
        </a>
        <p data-testid="footer-subtitle" className="mt-4 text-base text-paper/80">Impressão profissional para empresas.</p>
      </div>
      <div className="lg:col-span-4 lg:col-start-9 space-y-5 text-sm text-paper/80">
        <div><p className="font-mono text-[11px] uppercase tracking-[0.25em] text-paper/60">Endereço</p><p data-testid="footer-address" className="mt-1">{CONTACT.address}</p></div>
        <div><p className="font-mono text-[11px] uppercase tracking-[0.25em] text-paper/60">Horário</p><p className="mt-1">{CONTACT.hours}</p></div>
        <div><p className="font-mono text-[11px] uppercase tracking-[0.25em] text-paper/60">WhatsApp</p><p className="mt-1">{CONTACT.phone}</p></div>
      </div>
    </div>
    <MapEmbed />
    <motion.div initial={{ y: "30%", opacity: 0 }} whileInView={{ y: "0%", opacity: 1 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }} className="mt-16">
      <Wordmark dark lg testId="footer-logo" />
    </motion.div>
    <div className="mt-8 flex flex-col sm:flex-row justify-between gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-paper/60 border-t border-paper/15 pt-6">
      <span>© {new Date().getFullYear()} Alfa Gráfica Digital</span>
      <span data-testid="footer-tagline">Agilidade que sua empresa precisa.</span>
    </div>
  </footer>
);
